//Only supports number starting with 6 to 9 and upto 10 digits only
export const isMobileNumberIndian = function (mobileNumber) {
  return /^[6-9]\d{9}$/.test(mobileNumber);
};
